
/**
 * Lets you scope result of function call so it's not called multiple times
 * Instead of <b-icon :icon="getData(props.row).icon" :type="getData(props.row).type"/>
 * it can be scoped like following:
 * <with :data="getData(props.row)">
 *  <template v-slot:default="{ data }">
 *    <b-icon :icon="getDat(props.row).icon" :type="getDat(props.row).type"/>
 *  </template/>
 * </with>
 */
import Vue, { VNode, RenderContext } from "vue";

export default Vue.extend({
  name: "With",
  functional: true,
  props: {
    data: {
      type: Object,
      default: null
    },
    slotProp: {
      type: String,
      default: "data"
    },
    tag: {
      type: String,
      default: null
    }
  },
  render(h, { scopedSlots, props, ...ctx }: RenderContext) {
    const keys = Object.keys(scopedSlots);
    const result = keys.map(slotName => {
      if (slotName === "default")
        return scopedSlots[slotName]({
          [props.slotProp]: props.data
        }) as VNode[];
      else if (ctx.data?.attrs && ctx.data?.attrs[slotName])
        return scopedSlots[slotName]({
          [slotName]: ctx.data.attrs[slotName]
        }) as VNode[];
      else if (props[slotName])
        return scopedSlots[slotName]({
          [slotName]: props[slotName]
        }) as VNode[];
    });

    if (props.tag) return h(props.tag, {}, result);
    // @ts-ignore
    return result as VNode[];
  }
});
